import * as React from 'react'

import { MultiColumnIconSvgGroup } from './styles'

export const MultiColumnIcon: React.FC<{ isSelected: boolean }> = ({ isSelected }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12px'
      height='12px'
      viewBox='0 0 12 12'
      version='1.1'
    >
      <g id='Page-1' stroke='none' fill='none' fillRule='evenodd'>
        <MultiColumnIconSvgGroup
          isSelected={isSelected}
          transform='translate(-339.000000, -385.000000)'
        >
          <g id='view-selection' transform='translate(287.000000, 381.000000)'>
            <g transform='translate(52.000000, 4.000000)'>
              <rect id='Rectangle-Copy' x='0' y='0' width='5.4' height='5.4' />
              <rect id='Rectangle-Copy-3' x='0' y='6.6' width='5.4' height='5.4' />
              <rect id='Rectangle-Copy-2' x='6.6' y='0' width='5.4' height='5.4' />
              <rect id='Rectangle-Copy-4' x='6.6' y='6.6' width='5.4' height='5.4' />
            </g>
          </g>
        </MultiColumnIconSvgGroup>
      </g>
    </svg>
  )
}
